import React from "react";
import { Help } from "player-components";
import Faqs from "../../components/faqs";
import { selectClientConfig } from "../../features/ui/uiSlice";
import { useSelector } from "react-redux";



const HelpPage = () => {

	// pgw testing
  // const clientConfiguration = useSelector(selectClientConfig);

// pgw testing 13-may-2024
console.log('HelpPage p1')
// alert('help')

  return (

    <div className="overflow-auto ">
      <div className="relative py-16 pb-4 bg-white overflow-hidden">

        <div className="relative px-4 sm:px-6 lg:px-8">

          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Choir Player features list
              </span>
            </h1>
          </div>

          <div className="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            
            <ul role="list">

              <li>
SEPARATE VOLUME CONTROL of Soprano, Alto, Tenor, Bass and Backing track: The volume level of
all 5 parts can be set exactly how you want them including turning any of the parts off completely.
			</li>

              <li>
SOLO: A shortcut to isolating any 1 part (same as muting the other 4).
              </li>


              <li>
RESET LEVELS: Instantly reset all 5 parts to full volume
              </li>

              <li>
LYRICS: Scroll on screen as the song progresses. You can see which vocal part is singing which lines. The lyric feature can be switched on and off.
              </li>

              <li>
GO TO SECTION: Instantly jump to any song section (verse, bridge, chorus etc.)
              </li>

              <li>
LOOP: Tap the Loop button at any point in the song and the section which is playing will repeat until
Loop is tapped again.
              </li>

              <li>
SPEED: Slow down or speed up the tempo without changing pitch.
             </li>

             <li>
PITCH: Change key
            </li>

            <li>
RESET SPEED/PITCH: Instantly return the tempo and key to the original settings
           </li>
            </ul>
               <strong>Here is a link to a detailed user guide: </strong>
				<a href="https://choirplayer.com/user-guide/">Choir Player user guide</a>
			<br/>
			<br/>
               <strong>Please go here to see your Choir Page account details: </strong>
				<a href="https://choirplayer.com/my-account/">Choir Player account</a>
			<br/>
			<br/>
			<br/>
			<br/>
			<br/>
			<br/>
			<br/>

          {/* <Faqs /> */}
          </div>
        </div>
      </div>
    </div>
  

);
};
export default HelpPage;


